var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFullProtect = function SvgFullProtect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "currentColor",
    viewBox: "0 0 10 10"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 9.156q-1.458-.365-2.396-1.692a4.94 4.94 0 0 1-.937-2.912V2.073L5 .823l3.333 1.25v2.48a4.94 4.94 0 0 1-.937 2.91Q6.458 8.793 5 9.157"
  })));
};
export default SvgFullProtect;